<template>
  <div class="wallet-warp">
    <div class="content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="我的钱包" name="first">
          <Overview v-if="activeName === 'first'" />
        </el-tab-pane>
        <el-tab-pane label="历史充值订单" name="second">
          <TopUp v-if="activeName === 'second'" />
        </el-tab-pane>
        <el-tab-pane label="流水记录" name="third">
          <FlowRecord v-if="activeName === 'third'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Overview from './Overview.vue'
import TopUp from './TopUp.vue'
import FlowRecord from './FlowRecord.vue'
export default {
  components: { Overview, TopUp, FlowRecord },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="scss" scoped>
.wallet-warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .content {
    background: #fff;
    height: 100%;
  }
  .el-tabs {
    height: 100%;
  }
}
</style>
<style lang="scss">
.wallet-warp {
  .el-tabs__content {
    height: calc(100% - 56px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>